<div class="tw-relative tw-w-screen tw-min-w-[360px] tw-mx-auto">
  <div
    class="tw-absolute tw-right-3 tw-top-3 tw-w-6 tw-h-6 tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-z-10"
    (click)="onClose()"
    aria-label="Close">
    <em class="cs-icon-close tw-text-[20px] tw-text-gray-800"></em>
  </div>
  <app-follow-up-questions-widget
    [followUp]="data.followUp"
    [user]="data.user"
    [userImageUrl]="data.userImageUrl"
    placement="sheet"
    (completed)="onCompleted()"
    (fallbackToChat)="onFallback()">
  </app-follow-up-questions-widget>
</div>
